import Login from "~/features/Auth/pages/Login";
import Register from "~/features/Auth/pages/Register";
import {EmptyLayout} from "~/layout";

export const publicRoutes = [
	{ path: "/login", component: Login, layout: EmptyLayout },
	{ path: "/register", component: Register, layout: EmptyLayout },
];